import ReactApexChart from 'react-apexcharts';

const BarChart = ({ options, series, height, width }) => (
  <ReactApexChart
    options={options}
    series={series}
    type="bar"
    height={height ?? 300}
    width={width ?? 500}
  />
);

export default BarChart;
